import { render, staticRenderFns } from "./PaymentStigg.vue?vue&type=template&id=7f8ba740&scoped=true&"
import script from "./PaymentStigg.vue?vue&type=script&lang=js&"
export * from "./PaymentStigg.vue?vue&type=script&lang=js&"
import style0 from "./PaymentStigg.vue?vue&type=style&index=0&id=7f8ba740&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8ba740",
  null
  
)

export default component.exports